import React from "react";
import { ManageTradeLayout } from "../../../components";
import { Button, Image } from "react-bootstrap";
import {
  manageTradeFormNames,
  formFields,
  getPathWithParam,
  MANAGE_TRADE_ROUTES,
} from "../../../utils";
import { SearchView } from "../SearchView";
import { CardsLayout } from "../CardsLayout";
import ExcelImage from "../../../styles/exportimg.PNG";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faFolder } from "@fortawesome/pro-light-svg-icons";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom";
const columns = [
  {
    id: "fileId",
    label: "File ID",
    style: { paddingLeft: "0.5rem", fontSize: "14px", width: "20%" },
    className: "grey-text font-weight-700",
    styleName: "trade-file w-20",
  },
  {
    id: "clearingPartner",
    label: "Clearing Partner",
    style: { fontSize: "14px", width: "20%" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-20",
  },
  {
    id: "clearingPartnerId",
    label: "Clearing Partner ID",
    style: { fontSize: "14px", width: "20%" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-20",
  },
  {
    id: "aggregation",
    label: "Aggregatiion",
    style: { fontSize: "14px", width: "20%" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-20",
  },
  {
    id: "date",
    label: "Date",
    style: { fontSize: "14px", width: "20%" },
    className: "grey-text font-weight-700",
    styleName: "trade-ssn-column w-20",
  },
];

const TradeOrderInstructionContainer = (props) => {
  const TableContent = {
    fileId: (a, e) => {
      console.log(a, e, "args");
      return (
        <div className={a.styleName}>
          <FontAwesomeIcon icon={faFolder} />
          <div className="trade-file-Id">{"AD12314313"}</div>
        </div>
      );
    },
    aggregation: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    clearingPartnerId: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    clearingPartner: (a, e) => <div className={a.styleName}>XXXX2345</div>,
    date: (a, e) => {
      console.log(a, e, "args");
      return (
        <div className={a.styleName}>
          <div className="transaction-card-top-row">{"6/6/2023 5:40"}</div>
        </div>
      );
    },
  };
  const onSubmit = () => {};
  return (
    <CardsLayout>
      <div className="column-filters">
        {columns.map((_) => (
          <div className={_.className} style={{ ..._.style }}>
            {" "}
            {_.label}
          </div>
        ))}
      </div>
      {[1, 2, 3, 4, 5, 6, 7, 8].map((e, i) => {
        return (
          <Link
            className="generic-table-component trade-order-instruction"
            to={getPathWithParam({
              path: MANAGE_TRADE_ROUTES.TRADE_ORDER_INVESTMENT,
            })}
          >
            {columns.map((a, b) => {
              console.log(a, "regs");
              // const args = {...a,...e}
              return TableContent[a.id](a, e);
            })}
          </Link>
        );
      })}
    </CardsLayout>
  );
};

export default TradeOrderInstructionContainer;
